import { render } from "./SkeletonsConatainer.vue?vue&type=template&id=7fc078f9&scoped=true"
import script from "./SkeletonsConatainer.vue?vue&type=script&lang=js"
export * from "./SkeletonsConatainer.vue?vue&type=script&lang=js"

import "./SkeletonsConatainer.vue?vue&type=style&index=0&id=7fc078f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc078f9"]])

export default __exports__